import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Logo } from "@/components/Logo";
import { api } from "@/lib/api";

export function ResetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") ?? "";
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/api/auth/reset-password", { token, password });
      toast.success("Password updated — please sign in.");
      nav("/login");
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Could not reset password");
    } finally {
      setBusy(false);
    }
  }

  if (!token) return <div className="p-10 text-center">Missing token.</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-admin-surface p-6">
      <form onSubmit={onSubmit} className="w-full max-w-sm space-y-4 bg-admin-panel border border-admin-border rounded-md p-6">
        <div className="flex justify-center mb-2">
          <Logo variant="wordmark" className="text-3xl" />
        </div>
        <h1 className="font-head text-lg font-semibold text-center">Choose a new password</h1>
        <div className="space-y-1.5">
          <Label htmlFor="password">New password</Label>
          <Input id="password" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={12} />
        </div>
        <Button className="w-full" disabled={busy}>{busy ? "Saving…" : "Save password"}</Button>
      </form>
    </div>
  );
}
